import { render, staticRenderFns } from "./ToggleGroup.vue?vue&type=template&id=04938234&scoped=true&"
import script from "./ToggleGroup.vue?vue&type=script&lang=js&"
export * from "./ToggleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04938234",
  null
  
)

export default component.exports